export default __webpack_public_path__ + "images/2ccded07f4fa218eab22ea5bb56d01f6.png";